import React, { useRef } from 'react';

import cn from 'classnames';
import { Link } from 'react-router-dom';

import { useClickOutside } from '../../hooks/click-outside';
import styles from './TagsMenu.module.scss';

export const TagsMenu = ({
  visible,
  tags = [],
  onSelect = () => {},
  bulkTagDeletion = () => {},
  onClose = () => {},
  hideDeletion = false,
  position = 'top',
}) => {
  const ref = useRef(null);
  useClickOutside(ref, onClose);

  return (
    <ul className={cn(styles.root, styles[position], { [styles.rootVisible]: visible })} ref={ref}>
      {tags.map(tag => (
        <li key={tag.id} className={styles.tagItem} onClick={() => onSelect(tag.id)}>
          <span className={styles.tagDot} style={{ '--tag-color': tag.color }} />
          {tag.name}
        </li>
      ))}
      {tags.length > 1 && !hideDeletion && (
        <li className={styles.removeOption} onClick={bulkTagDeletion}>
          Remove all tags
        </li>
      )}
      {tags.length < 1 && (
        <li>
          There are no tags yet.{' '}
          <Link to="/account/tags" className="u-link">
            Start here
          </Link>
        </li>
      )}
    </ul>
  );
};
